import React from "react";
import { Button, TextField } from "@mui/material";
import {
  Add as AddIcon,
  Save as SaveIcon,
  Cancel as CancelIcon,
} from "@mui/icons-material";
import { toast } from "react-toastify";
import {
  convertPresetsToDb,
  isTimeOverlapping,
  handleAddSchedule,
} from "./utils";
import TimeSlotList from "./TimeSlotList";
import * as S from "./styles";

function EditPresetForm({
  editingPreset,
  setEditingPreset,
  editMutation,
  group_code,
  project_code,
}) {
  const handleSaveEdit = () => {
    if (!editingPreset.name.trim()) {
      alert("프리셋 이름을 입력해주세요.");
      return;
    }
    const timeValidation = isTimeOverlapping(editingPreset.schedules);
    if (!timeValidation.isValid) {
      toast.error(timeValidation.message);
      return;
    }
    setEditingPreset(null);
    editMutation.mutate(
      {
        data: convertPresetsToDb(editingPreset, true),
        group_code,
        project_code,
      },
      {
        onSuccess: () => {
          toast.success("수정이 완료되었습니다.");
        },
        onError: (e) => {
          toast.error(e.response.data.message);
        },
      }
    );
  };

  return (
    <S.PresetForm elevation={3}>
      <div style={{ display: "flex", gap: "1rem" }}>
        <TextField
          sx={{ width: "50%" }}
          value={editingPreset.name}
          onChange={(e) =>
            setEditingPreset({
              ...editingPreset,
              name: e.target.value,
            })
          }
          margin="normal"
          size="small"
        />
        <TextField
          sx={{ width: "50%" }}
          value={editingPreset.description}
          onChange={(e) =>
            setEditingPreset({
              ...editingPreset,
              description: e.target.value,
            })
          }
          margin="normal"
          size="small"
        />
      </div>

      <TimeSlotList preset={editingPreset} setPreset={setEditingPreset} />

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginTop: "1rem",
        }}
      >
        <Button
          startIcon={<AddIcon />}
          onClick={() => handleAddSchedule(editingPreset, setEditingPreset)}
          color="primary"
        >
          시간 추가
        </Button>
        <div style={{ display: "flex", gap: "0.5rem" }}>
          <Button
            startIcon={<CancelIcon />}
            onClick={() => setEditingPreset(null)}
          >
            취소
          </Button>
          <Button
            variant="contained"
            startIcon={<SaveIcon />}
            onClick={handleSaveEdit}
          >
            저장
          </Button>
        </div>
      </div>
    </S.PresetForm>
  );
}

export default EditPresetForm;
